import { render } from "./NotFoundPage.vue?vue&type=template&id=4eff7ff6"
const script = {}

import "./NotFoundPage.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__